import React from "react";
import { Phone } from "lucide-react";
import { BUSINESS } from "../../lib/config";

export default function FloatingCall() {
  return (
    <a
      href={BUSINESS.phoneHref}
      className="floating-call sm:hidden"
      data-testid="floating-call-btn"
      aria-label={`Call ${BUSINESS.phone}`}
    >
      <Phone className="w-5 h-5" /> Call Now
    </a>
  );
}
